let toggleBtn = document.querySelector('.js-contact-toggle');
let contactWrapper = document.querySelector('.js-contact-sidebar');
let contactCloseBtn = document.querySelector('.js-contact-close');
let body = document.querySelector('body');

toggleBtn.addEventListener('click', function () {
    contactWrapper.classList.toggle('js-hide-sidebar');
    body.classList.toggle('scrollock');

});

contactCloseBtn.addEventListener('click', function () {
    contactWrapper.classList.toggle('js-hide-sidebar');
    body.classList.toggle('scrollock');

});

// Click outside
document.addEventListener("click", e => {
    if (e.target.closest('.js-contact-sidebar') || contactWrapper.classList.contains('js-hide-sidebar')) return;
    contactWrapper.classList.toggle('js-hide-sidebar');
    body.classList.toggle('scrollock');
});

// Escape key closes sidebar
document.addEventListener('keydown', e => {
    if (e.key === "Escape") {
        contactWrapper.classList.add('js-hide-sidebar');
        body.classList.remove('scrollock');
    }
});